export const FECHA_MES = {
    Enero: 'Enero'
    //en este espacio agregar los demas y asi sucesivamente 
};

////// Meses de forma corta
export const MONTHS_SHORT = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

////// Textos del contenedor TimeSelection 
export const TIME_SELECTION_CONTAINER = {
    DAY: 'Día',
    FROM: 'De',
    JANUARY_JUNE: 'Enero - Junio',
    JULY_DECEMBER: 'Julio - Diciembre',
    MONTH: 'Mes',
    RANGE: 'Rango',
    SEMESTER: 'Semestre',
    TO: 'a',
    YEAR: 'Año',
}

////// Textos del contenedor MapSelection 
export const MAP_SELECTION_CONTAINER = {
    SEARCH_NEIGBORHOOD: 'Buscar barrio',
    DIVISION_POLITICA_ADMINISTRATIVA: 'División Política Administrativa',
    SHOW_RESULTS: 'Resultados',
    CUADRANTES: 'Cuadrantes',
    CASES: 'Casos',
    DENSITY: 'Densidad',
    HEAT: 'Calor',
    SEMESTER: 'Semestre',
    TO: 'a',
    YEAR: 'Año',
}

export const DOUGHNUT_DASHBOARD_CONTAINER = {
    COLORS: 'Colores',
    CHANGE_CHART: 'Cambiar gráfica',
    WATCH_MORE: 'Ver más',
    WATCH_RATE: 'Ver tasa',
    WATCH_TEN: 'Ampliar top',
    WATCH_FENOMENE: 'Ver fenómeno',
    COLLECT: 'Coleccionar',
    DOWNLOAD: 'Descargar',
    EARLY_MORNING: 'Madrugada',
    MORNING: 'Mañana',
    AFTERNOON: 'Tarde',
    NIGHT: 'Nocha',
    TOTAL: 'Total',
    YEAR: 'Año',

}

export const LANDING_MENU_BAR = {
    ADMIN: 'Administración',
    ADMIN_USER: 'Administrar usuarios',                       //Submenu
    CITY_CARD: 'Ficha Municipal',                       //Menu
    COMMUNAL_FILE: 'Ficha Comunal',                       //Menu
    PISCC_INDICATORS: 'Indicadores PISCC',              //Menu
    PERCEPTION: 'Percepción Ciudadana',                 //Menu
    INFOMR_GENERAL: 'Informe General',                  //Submenu
    WEEKLY_BEHAVIOR: 'Comportamiento Semanal',                  //Submenu
    SIEDCO: 'Informe Detallado Denuncias',                                //Menu
    SECAD: 'Informe Detallado Llamadas 123',            //Menu
    SITUATION_BY_COMMUNE: 'Situación por Comuna',
    STATISTICS_PERCEPTION: 'Percepción',                //Submenu
    STATISTICS_QUALIFICATION: 'Calificación',           //Submenu
    STATISTICS_VICTIMIZATION: 'Victimización',          //Submenu
    STATISTICS_LINE123: 'Línea 123',                    //Submenu
    STATISTICS_GEOREFERENCING: 'Georreferenciación',     //Submenu
    STATISTICS_THEFTS: 'Hurtos',                        //Submenu
    CARACTERIZATIONS: 'Caracterizaciones',          //Submenu
    CREATE_FONEMENES: 'Creación de fenómenos',          //Submenu
    CREATE_INFORMS: 'Creación de informes',             //Submenu
    CREATE_USER: 'Crear usuario',                       //Submenu
    CENSE_MARKET: 'Censo Galería',                       //Submenu
    OPERATIVES: 'Operativos',                       //Submenu
    // CONFIG: 'Configuración',                         //Menu
    DATA: 'Datos',                                      //Menu
    DATA_LOAD: 'Carga de datos',                        //Menu
    DASHBOARD: 'Dashboard',                             //Menu
    DOWNLOAD_EXCEL: 'Descargar Excel',                             //Submenu
    DOWNLOAD_FILES: 'Descargar Archivos',                             //Submenu
    EP: 'Espacio Público',                                      //Menu
    GENERATE_INFORM: 'Generar Informe',
    GIS: 'SIG',                                         //Menu
    HOME: 'Inicio',                                     //Menu
    INCAUTATIONS: 'Incautaciones',               //Submenu
    INDIVIDUALE_LOAD: 'Carga individual',               //Submenu
    INFOMR_GENERATOS: 'Generador de informes',          //Submenu
    INFOMR_WEEKLY: 'Informe automático',                   //Submenu
    INSPECTORS: 'Inspectores',                             //Submenu
    FUNCTIONEERS: 'Funcionarios',                             //Submenu
    MASSIVE_LOAD: 'Carga masiva',                       //Submenu
    REQUESTS: 'Solicitudes',                       //Submenu
    LOAD_MAP: 'Cargar mapa',                       //Submenu
    MODIFICATE_USER: 'Modificación de usuario',         //Submenu
    MORE: 'Más',                                        //Menu
    CLOSE_SESSION: 'Cerrar sesión',                     //Submenu
    CHANGE_PASSWORD: 'Cambiar contraseña',              //Submenu
    ADVERTISE: 'Publicidad',               //Submenu
    CHANGE_LOGOS: 'Cambiar logos',              //Submenu
}

export const LANDING_FOOTER = {
    ADDRESS: 'Dirección',
    LINE_ATENTION_CITYZENSHIP: 'Línea de atención a la ciudadanía',
    PQR: 'Peticiones, quejas y reclamos',
    USER: 'Usuario',
    USER_ATENTION: 'Atención al Usuario',
    TIME_ATENTION: 'Horario de atención',
}

export const CREATE_INFORM = {
    COPY_CLIPBOARD: 'Copiar',
    CREATE_COPY: 'Crear copia',
    DELETE: 'Eliminar',
    DOWNLOAD: 'Descargar',
    NO_GRAPHICS: 'Sin gráficas acumuladas',
    PASTE_CLIPBOARD: 'Pegar',
    SOURCE_CALIBRI_10: 'Fuente Calibri 10',
    SUBTITLE_CALIBRI_14: 'Subtítulo Calibri 14',
    TEXTS: 'Textos',
    TEXT_BUDY_CALIBRI_12: 'Cuerpo de texto Calibri 12',
    TITLE_CALIBRI_16: 'Título Calibri 16',
}

export const LOGIN = {
    USER: "Usuario",
    EMAIL: "Correo",
    PASSWORD: "Contraseña",
    LOGIN: "Iniciar Sesión"
}

export const CHANGEPASSWORD = {
    EMAIL: "Correo",
    OLDPASSWORD: "Contraseña",
    NEWPASSWORD: "Nueva Contraseña",
    CONFIRMPASSWORD: "Confirme Contraseña",
    CHANGEPASSWORD: "Cambiar Contraseña",
}


export const INFORM_GENERATOR = {
    GENERATE_INFORM: 'Generar Informe',
    INFORM_TYPE: 'Tipo de Informe',
    INFORM_TIME: 'Periodo del informe',
    INFORM_ZONE: 'Región del informe',
    SELECT_KIND_INFORM: 'Seleccione un tipo de informe',
    SELECT_TIME_INFORM: 'Seleccionar un periodo',
    INIT_DATE: 'Fecha inicial',
    END_DATE: 'Fecha final',
    INFORM_TIME_OPS: [
        { value: 0, text: 'Por rango de tiempo' },
        { value: 1, text: 'Última semana' },
        { value: 2, text: 'Último mes' },
        { value: 3, text: 'Último año' },
        { value: 4, text: 'Semana actual' },
        { value: 5, text: 'Mes actual' },
        { value: 6, text: 'Año actual' }
    ],
    MPIOS_BY_ID: [
        { text: 'Apartadó', id: 1 },
        { text: 'Carepa', id: 2 },
        { text: 'Chigorodó', id: 3 },
        { text: 'Mutatá', id: 4 },
        { text: 'Necoclí', id: 5 },
        { text: 'Turbo', id: 6 },
        { text: 'San Pedro de Urabá', id: 7 },
        { text: 'San Juan de Urabá', id: 8 },
        { text: 'Murindó', id: 9 },
        { text: 'Arboletes', id: 10 },
    ],
    ZONES: [
        { name: 'Rural', id: 1 },
        { name: 'Urbana', id: 2 },
    ],
    FENOMENES: [
        { name: 'Homicidios', id: 1 },
        { name: 'Hurto', id: 2 },
        { name: 'Delitos Sexuales', id: 3 },
        { name: 'Violencia intrafamieliar', id: 4 },
        { name: 'Recuperaciones', id: 5 },
        { name: 'Incautaciones', id: 6 },
        { name: 'Accidentalidad', id: 7 },
        { name: 'Infraestructura', id: 8 },
        { name: 'Comparendos', id: 9 },
        { name: 'Otro', id: 10 },
    ],
    INFORM_TYPE_OPS: [
        // { value: 1, text: 'Amenazas' },
        // { value: 2, text: 'Delitos sexuales' },
        // { value: 3, text: 'Extorsion' },
        // { value: 4, text: 'Feminicidios' },
        // { value: 5, text: 'Homicidios' },
        // { value: 6, text: 'Homicidio culposo' },
        // { value: 7, text: 'Hurtos generales' },
        // { value: 11, text: 'Terrorismo' },
        // { value: 12, text: 'Secuestro' },
        { value: 1, text: 'Homicidios' },
        { value: 3, text: 'Hurto a motocicletas' },
        { value: 4, text: 'Hurto a automotores' },
        { value: 5, text: 'Hurto a personas' },
        { value: 6, text: 'Hurto a residencias' },
        { value: 7, text: 'Hurto a comercio' },
        { value: 8, text: 'Hurto a bancos' },
        { value: 11, text: 'Lesiones personales' },
    ],
    INFORM_TYPE_TEST: [
        { value: 1, text: 'Homicidios' },
        { value: 5, text: 'Hurto a personas' },
        { value: 6, text: 'Hurto a residencias' },
        { value: 4, text: 'Hurto a automotores' },
        { value: 3, text: 'Hurto a motocicletas' },
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
        // {value: 1, text: 'Homicidios'},
        // {value: 5, text: 'Hurto a personas'},
        // {value: 6, text: 'Hurto a residencias'},
        // {value: 4, text: 'Hurto a automotores'},
        // {value: 3, text: 'Hurto a motocicletas'},
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
        // {value: 1, text: 'Homicidios'},
        // {value: 5, text: 'Hurto a personas'},
        // {value: 6, text: 'Hurto a residencias'},
        // {value: 4, text: 'Hurto a automotores'},
        // {value: 3, text: 'Hurto a motocicletas'},
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
    ],
    ZONES_BY_ID: [
        { value: 'ASOMURA', text: 'Asomura', id: 0 },
        { value: 'Apartadó', text: 'Apartadó', id: 1 },
        { value: 'Arboletes', text: 'Arboletes', id: 10 },
        { value: 'Carepa', text: 'Carepa', id: 2 },
        { value: 'Chigorodó', text: 'Chigorodó', id: 3 },
        { value: 'Murindó', text: 'Murindó', id: 9 },
        { value: 'Mutatá', text: 'Mutatá', id: 4 },
        { value: 'Necoclí', text: 'Necoclí', id: 5 },
        { value: 'San Juan de Urabá', text: 'San Juan de Urabá', id: 8 },
        { value: 'San Pedro de Urabá', text: 'San Pedro de Urabá', id: 7 },
        { value: 'Turbo', text: 'Turbo', id: 6 },
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
        // {value: 1, text: 'Homicidios'},
        // {value: 5, text: 'Hurto a personas'},
        // {value: 6, text: 'Hurto a residencias'},
        // {value: 4, text: 'Hurto a automotores'},
        // {value: 3, text: 'Hurto a motocicletas'},
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
        // {value: 1, text: 'Homicidios'},
        // {value: 5, text: 'Hurto a personas'},
        // {value: 6, text: 'Hurto a residencias'},
        // {value: 4, text: 'Hurto a automotores'},
        // {value: 3, text: 'Hurto a motocicletas'},
        // {value: 7, text: 'Hurto a comercio'},
        // {value: 8, text: 'Hurto a bancos'},
        // {value: 11, text: 'Lesiones personales'},
    ]

}

export const FORM = {
    ACCEPT: 'Aceptar',
    CANCEL: 'Cancelar',
    DATE: 'Fecha',
    EDIT: 'Editar',
    NAME: 'Nombre',
    NEW: 'Nuevo',
    OPEN: 'Abrir',
    OPEN_FILE: 'Abrir archivo',
    PDF: 'Pdf',
    SAVE: 'Guardar',
    SAVE_AS: 'Guardar como',
    SAVE_FILE_AS: 'Guardar archivo como',
    USER: 'Usuario',
}

// export const MPIOS = {
//     apartado: { DPTOMPIO: '05045',
// Carepa: 05147
// Chigorodó: 05172
// Mutatá: 05480
// Necoclí: 05490
// Turbo: 05837
// San Pedro de Urabá: 05665
// San Juan de Urabá: 05659
// Vigia del Fuerte: 05873
// Muridó: 05475
// Arboletes: 05051
// }